import './App.css';
import './styles/responsive-marketing.css';
import RouteComponent from './components/RouteComponent';
function App() {
  return (
  <div>
      <RouteComponent/>
    </div>
  );
}
export default App;
